import Phaser from 'phaser';
import { getPieceMoveSet } from './movementHelpers';
import { WALKABLE } from './constants';

/*
/* Pathing finding on Open World
/**/
export function getPathToTile(groundTile, piece, animateMove, doneMoving) {
  if (!groundTile || !piece || !piece.tile) {
    doneMoving && doneMoving(true);
    return;
  }
  const originTile = piece.tile;
  const startingDist = Phaser.Math.Distance.Between(
    groundTile.x,
    groundTile.y,
    originTile.x,
    originTile.y
  );
  if (startingDist === 0) {
    return;
  }
  const path = Astar(piece, originTile, groundTile);
  followPath(piece, path, 0, animateMove, doneMoving);
  return;
}

function followPath(piece, path, index, animateMove, done) {
  if (!path || !path.length) {
    return done(true);
  }
  const current = path[index];
  const next = path[index + 1];
  if (next) {
    const nextPiece = piece.tile.tilemap.getTileAt(
      next.x,
      next.y,
      true,
      'logic_layer'
    );
    const currentGround = piece.tile.tilemap.getTileAt(
      current.x,
      current.y,
      true,
      'ground_layer'
    );
    const last = index + 2 === path.length;
    animateMove(piece, nextPiece, currentGround, false, !last, unit => {
      if (unit && unit.scene) {
        if (!last && !unit.scene.battlingInWorld) {
          followPath(unit, path, index + 1, animateMove, done);
        } else {
          done();
        }
      }
    });
  } else {
    done();
  }
}

export function Astar(piece, start, end) {
  const startTime = new Date().getTime();
  const startNode = {
    ...start,
    f: 0,
    g: 0,
    h: 0
  };
  let open = [];
  let closed = [];
  open.push(startNode);
  let limit = 0;
  while (open.length) {
    limit += 1;
    const now = new Date().getTime();
    if (limit > 5000 || now - startTime >= 60) {
      open = null;
      return [];
    }
    let currentNode = open[0];
    let currentIndex = 0;
    if (open.length > 1) {
      open.forEach((openNode, index) => {
        if (openNode.f < currentNode.f) {
          currentNode = openNode;
          currentIndex = index;
        }
      });
    }

    open.splice(currentIndex, 1);
    closed.push(currentNode);

    const reachedGoal = currentNode.x === end.x && currentNode.y === end.y;
    if (reachedGoal) {
      const path = [];
      let current = currentNode;
      while (current) {
        path.push(current);
        current = current.parent;
      }
      path.reverse();
      return path;
    }
    let moveset = getPieceMoveSet(
      { ...currentNode, index: piece.tile.index },
      start.tilemap,
      null,
      null,
      piece.ss
    );
    // dont hit any other doors along the way
    moveset.moveSet = moveset.moveSet.filter(move => {
      const isNPC = move.index === WALKABLE;
      const isEndTile = move.x === end.x && move.y === end.y;
      return (!move.goal && !isNPC) || isEndTile;
    });
    for (var i = 0; i < moveset.moveSet.length; i++) {
      const move = moveset.moveSet[i];

      //continue if in closed list
      const inClosed = closed.find(
        closedNode => closedNode.x === move.x && closedNode.y === move.y
      );
      if (inClosed) {
        continue;
      }

      const g =
        currentNode.g +
        Phaser.Math.Distance.Between(move.x, move.y, start.x, start.y);
      const h = Phaser.Math.Distance.Between(move.x, move.y, end.x, end.y);
      const f = g + h;

      const child = { ...move, f, g, h, parent: currentNode };

      //continue if child position in open list
      const inOpen = open.find(
        openNode => openNode.x === move.x && openNode.y === move.y
      );
      if (inOpen && inOpen.g < child.g) {
        continue;
      }
      open.push(child);
    }
  }
}
